import { createSlice } from "@reduxjs/toolkit";

export const initialStateForCommonSlice = {
    paramMasterList: [],
    plateforms: [],
    niches: [],
    message: "",
    title: "",
    img: "",
    status: false,
    getPlanButton: false,
    socket: {},
    influencerType: [],
    userDetails: {},
    userInfo: {},
    fixedSubscriptions: [],
    triggerTable: [],
    isScreenZoomed:false,
};

export const commonSlice = createSlice({
    name: "commonSlice",
    initialState:initialStateForCommonSlice,
    reducers: {
        updateCommonData: (state, action) => {
            return { ...state, ...action.payload };
        },
        resetCommonData: (state, action) => {
            return initialStateForCommonSlice;
        },
    },
});

// Action creators are generated for each case reducer function
export const { updateCommonData, resetCommonData } = commonSlice.actions;

export default commonSlice.reducer;
